<template>
  <v-row class="mt-4" no-gutters>
    <v-col cols="12" lg="12" md="12" sm="12" xl="12" xs="12">
      <v-row>
<!--        <v-col cols="12" lg="6" md="6" sm="12" xl="6" xs="12">
          <store-select
              :available-items="storesByEmployee"
              :is-one-element="false"
              :multiple-select="true"
              @selectedStore="selectedStore"
          ></store-select>
        </v-col>-->
<!--        <v-col cols="12" lg="6" md="6" sm="12" xl="6" xs="12">
          <div class="display-item-center">
            <UploadFiles
                v-if="currentElement.uuid"
                :owner-id="currentElement.uuid"
                @downloadFiles="downloadFiles"
            ></UploadFiles>
          </div>
        </v-col>-->
      </v-row>
      <v-form class="mt-5" v-model="validForm" @input="inputForm">
        <v-row no-gutters>
          <v-col cols="12" lg="6" md="6" sm="12" xl="6" xs="12">
            <title-info-card
                icon="mdi-face-man-outline"
                textTitle="Información Personal"
            >
              <template #contentCard>
                <v-row class="mt-2">
                  <v-col cols="12" lg="6" md="6" sm="12" xl="6" xs="12">
                    <div>
                      <label class="input-label" for="Name*"
                      >Nombre<span class="required-field-form">*</span></label
                      >
                      <v-text-field
                          id="name"
                          v-model="currentElement.name"
                          :rules="required"
                          color="backofficeInput"
                          hide-details
                          outlined
                          placeholder="Ejemplo: Jose"
                      />
                    </div>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="12" xl="6" xs="12">
                    <div>
                      <label class="input-label" for="Last Name*"
                      >Apellidos<span class="required-field-form"
                      >*</span
                      ></label
                      >
                      <v-text-field
                          id="lastName"
                          v-model="currentElement.lastName"
                          :rules="required"
                          color="backofficeInput"
                          hide-details
                          outlined
                          placeholder="Ejemplo: Alvarez Lopéz"
                      />
                    </div>
                  </v-col>
                  <v-col cols="12" lg="12" md="12" sm="12" xl="12" xs="12">
                    <div>
                      <label class="input-label" for="email*"
                      >E-mail<span class="required-field-form">*</span></label
                      >
                      <v-text-field
                          id="email"
                          v-model="currentElement.email"
                          :rules="required"
                          color="backofficeInput"
                          hide-details
                          outlined
                          placeholder="Ejemplo: jose@backoffice.com"
                      />
                    </div>
                  </v-col>
                  <v-col cols="12" lg="7" md="7" sm="12" xl="7" xs="12">
                    <div>
                      <label class="input-label" for="Phone*"
                      >Teléfono<span class="required-field-form">*</span></label
                      >
                      <v-text-field
                          id="licensePlate"
                          v-model="currentElement.phone"
                          :rules="required"
                          color="backofficeInput"
                          hide-details
                          outlined
                          placeholder="Ejemplo: 4431256487"
                      />
                    </div>
                  </v-col>
                  <v-col cols="12" lg="5" md="5" sm="12" xl="5" xs="12">
                    <div>
                      <v-menu
                          ref="menu"
                          v-model="menu1"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          min-width="290px"
                          offset-y
                          transition="scale-transition"
                      >
                        <template v-slot:activator="{ on }">
                          <label class="input-label" for="Birthday"
                          >Fecha de nacimiento<span class="required-field-form"
                          >*</span
                          ></label
                          >
                          <v-text-field
                              id="Birthday"
                              :rules="birthday"
                              :value="currentElement.birthday"
                              hide-details
                              outlined
                              placeholder="Ejemplo: 1995-07-26"
                              readonly
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="currentElement.birthday"
                            scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn color="primary" text @click="menu1 = false"
                          >Cancel
                          </v-btn>
                          <v-btn
                              color="primary"
                              text
                              @click="$refs.menu.save(date)"
                          >OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </div>
                  </v-col>
                  <v-col
                      v-if="!hideField"
                      cols="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xl="12"
                      xs="12"
                  >
                    <div>
                      <label class="input-label" for="Password*"
                      >Contraseña
                        <span class="required-field-form"
                        >*</span
                        ></label
                      >
                      <v-text-field
                          id="Password"
                          v-model="currentElement.password"
                          :rules="required"
                          color="backofficeInput"
                          hide-details
                          outlined
                          placeholder="Ejemplo: 123@qwerty!"
                      />
                    </div>
                  </v-col>
                </v-row>
              </template>
            </title-info-card>
          </v-col>
        </v-row>
        <v-row class="mt-10 mb-10" no-gutters>
          <v-col cols="12" lg="6" md="6" sm="12" xl="6" xs="12">
            <title-info-card
                icon="mdi-text-box-check-outline"
                textTitle="Roles y permisos"
            >
              <template #contentCard>
                <v-row class="mt-2">
                  <v-col cols="12" lg="12" md="12" sm="12" xl="12" xs="12">
                    <select-cards
                        :available-items="rolesByEmployee"
                        :available-option="availableRoles"
                        :isArrayObject="true"
                        info="Roles"
                        isRequired
                        property-name="name"
                        @selectedItem="selectedItem"
                    ></select-cards>
                  </v-col>
                </v-row>
              </template>
            </title-info-card>
          </v-col>
        </v-row>
        <v-row class="mt-10" no-gutters>
          <v-col cols="12" lg="6" md="6" sm="12" xl="6" xs="12">
            <title-info-card icon="mdi-home-outline" textTitle="Dirección">
              <template #contentCard>
                <v-row class="mt-2">
                  <v-col cols="12" lg="12" md="12" sm="12" xl="12" xs="12">
                    <div>
                      <label class="input-label" for="Street">Calle </label>
                      <v-text-field
                          id="Street"
                          v-model="currentElement.address.street"
                          color="backofficeInput"
                          hide-details
                          outlined
                          placeholder="Ejemplo: Siempre viva #24, Doctores"
                      />
                    </div>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="12" xl="6" xs="12">
                    <div>
                      <label class="input-label" for="City">Ciudad </label>
                      <v-text-field
                          id="City"
                          v-model="currentElement.address.city"
                          color="backofficeInput"
                          hide-details
                          outlined
                          placeholder="California"
                      />
                    </div>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="12" xl="6" xs="12">
                    <div>
                      <label class="input-label" for="State">Estado</label>
                      <v-text-field
                          id="State"
                          v-model="currentElement.address.state"
                          color="backofficeInput"
                          hide-details
                          outlined
                          placeholder="Ejemplo: Jalisco"
                      />
                    </div>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="12" xl="6" xs="12">
                    <div>
                      <label class="input-label" for="Zip Code">Código Postal</label>
                      <v-text-field
                          id="Zip Code"
                          v-model="currentElement.address.zipCode"
                          color="backofficeInput"
                          hide-details
                          outlined
                          placeholder="Ejemplo: 58200"
                      />
                    </div>
                  </v-col>
                </v-row>
              </template>
            </title-info-card>
          </v-col>
        </v-row>
      </v-form>
<!--      <v-row v-if="currentElement.uuid" class="mt-5">
        <v-col cols="12" lg="12" md="12" sm="12" xl="12" xs="12">
          <show-files-uploaded
              ref="showFiles"
              :owner-id="currentElement.uuid"
              :selected-img="currentElement.photoImageName"
              msg-info="Please select a file to set a employee image"
              @reloadData="downloadFiles"
              @selectImage="selectImage"
          ></show-files-uploaded>
        </v-col>
      </v-row>-->
    </v-col>
  </v-row>
</template>

<script>
import TitleInfoCard from "@/components/TitleInfoCard.vue";
import {required, birthday} from "@/utils/validationRule";
import SelectCards from "@/components/SelectCard.vue";
/*import UploadFiles from "@/components/UploadFiles.vue";*/
/*import ShowFilesUploaded from "@/components/ShowFilesUploaded.vue";*/


export default {
  name: "FormVehicle",
  components: { TitleInfoCard, SelectCards},
  props: {
    currentElement: {
      type: Object,
      default: () => {
      },
    },
    availableRoles: {
      type: Array,
      default: () => [],
    },
    rolesByEmployee: {
      type: Array,
      default: () => [],
    },
    storesByEmployee: {
      type: Array,
      default: () => [],
    },
    hideField: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
      birthday,
      validForm: false,
      menu1: false,
      date: null,
    };
  },
  methods: {
    selectedItem(e) {
      this.$emit("selectedItem", e);
    },
    inputForm(e) {
      this.$emit("validFormInput", e);
    },
    downloadFiles() {
      if (this.$refs.showFiles) {
        this.$refs.showFiles.getFilesByOwnerId();
      }
    },
    selectImage(imageName) {
      this.$emit("selectImage", imageName);
    },
    selectedStore(store) {
      this.$emit('selectedStore', store)
    }
  },
};
</script>

<style scoped></style>
